import { useParams } from "react-router-dom";
import { useMovimentacaoBuscar } from "../../../../../Services/Financeiro/Conta/MovimentacaoService";
import TelaCarregamento from "../../../../Base/Carregamento/TelaCarregamento";
import MovimentacaoFormBasic, { IMovimentacaoFormBasicProps } from "./MovimentacaoFormBasic";
import { ReactElement } from "react";
import { Flex, Button, Divider } from "antd";
export interface IMovimentacaoVisualizarProps extends Omit<IMovimentacaoFormBasicProps, "onFinish"> {
    codigo?:number;
    buttoCencelar?: ReactElement;
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}
export default function MovimentacaoVisualizar({
    codigo : codigoParam,
    buttoCencelar,
    onCancelar,
    ...rest
}:IMovimentacaoVisualizarProps) {
    const { codigo : codigoRota } = useParams();
    const codigo = isNaN(Number.parseInt(codigoRota ?? "")) ? codigoParam : Number.parseInt(codigoRota ?? "");
    
    const {
        data,
        isLoading
    } = useMovimentacaoBuscar({
        codigo : codigo ?? 0,
        enabled : codigo !== undefined && !isNaN(codigo)
    });
     
    return <TelaCarregamento ativo={isLoading}>
        <MovimentacaoFormBasic 
            {...rest}
            initialValues={{
                movimentacao : data ?? undefined
            }}
            codigo={codigo}
            disabled={true}
        />

        <Divider />

        <Flex gap="small" wrap="wrap" justify="center">
            {!!buttoCencelar && buttoCencelar}
            {!!!buttoCencelar && !!onCancelar && (
                <Button type="primary" danger htmlType="reset" onClick={onCancelar}>
                    Voltar
                </Button>
            )}
        </Flex>
    </TelaCarregamento>
}